export const OBTER_TELAS_DISPONIVEIS_REQUEST =
  'OBTER_TELAS_DISPONIVEIS_REQUEST';
export const OBTER_TELAS_DISPONIVEIS_SUCCESS =
  'OBTER_TELAS_DISPONIVEIS_SUCCESS';
export const RESETA_TELAS_DISPONIVEIS_REQUEST =
  'RESETA_TELAS_DISPONIVEIS_REQUEST';
